/* =========================================================
   Pawpular - Boost AI Search & Filter Custom JS
   File: assets/boost-sd-custom.js

   功能：
   1. 顶部插入：筛选条件 / Clear all
   2. Pet 图标采用和 Brands 一样的制作方法：JS 插入真实 SVG，只控制标题图标
   3. Food 前插入食盆图标
   4. Toy / Toys / 玩具 前插入骨头图标
   5. Brand / Treats / Health Care / Other Essentials / Price / Size 前插入标签图标
   6. Brand 区域插入热门品牌按钮和字母分组
========================================================= */

(function () {
  function isFilterReady() {
    return Boolean(
      document.querySelector('.boost-sd__filter-tree') ||
      document.querySelector('.boost-sd__filter-tree-vertical') ||
      document.querySelector('.boost-pfs-filter-tree') ||
      document.querySelector('.boost-pfs-filter-tree-vertical')
    );
  }

  function getFilterTree() {
    return (
      document.querySelector('.boost-sd__filter-tree') ||
      document.querySelector('.boost-sd__filter-tree-vertical') ||
      document.querySelector('.boost-pfs-filter-tree') ||
      document.querySelector('.boost-pfs-filter-tree-vertical')
    );
  }

  function getFilterOptions() {
    return document.querySelectorAll(
      '.boost-sd__filter-option, .boost-pfs-filter-option'
    );
  }

  function getTitleTextElement(option) {
    return (
      option.querySelector('.boost-sd__filter-option-title-text') ||
      option.querySelector('.boost-pfs-filter-option-title-text') ||
      option.querySelector('.boost-sd__filter-option-title') ||
      option.querySelector('.boost-pfs-filter-option-title')
    );
  }

  function cleanTitleText(titleEl) {
    if (!titleEl) return '';

    const cloned = titleEl.cloneNode(true);

    cloned.querySelectorAll(
      '.paw-filter-title-icon, .paw-pet-title-icon, .paw-tag-title-icon, .paw-food-title-icon, .paw-toy-title-icon'
    ).forEach(function (el) {
      el.remove();
    });

    return (cloned.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getTitleText(option) {
    const titleEl = getTitleTextElement(option);
    return cleanTitleText(titleEl);
  }

  function isPetFilter(option) {
    const text = getTitleText(option);

    return (
      text === 'pet' ||
      text === 'pets' ||
      text === 'pet type' ||
      text === '宠物' ||
      text === '宠物类型' ||
      text.includes('pet') ||
      text.includes('宠物')
    );
  }

  function isBrandFilter(option) {
    const text = getTitleText(option);

    return (
      text === 'brand' ||
      text === 'brands' ||
      text === '品牌' ||
      text.includes('brand') ||
      text.includes('品牌')
    );
  }

  function isFoodFilter(option) {
    const text = getTitleText(option);

    return (
      text === 'food' ||
      text === 'foods' ||
      text === '食物' ||
      text === '食品' ||
      text === '主食' ||
      text.includes('food') ||
      text.includes('食物') ||
      text.includes('食品') ||
      text.includes('主食')
    );
  }

  function isToyFilter(option) {
    const text = getTitleText(option);

    return (
      text === 'toy' ||
      text === 'toys' ||
      text === '玩具' ||
      text.includes('toy') ||
      text.includes('玩具')
    );
  }

  function isTagIconFilter(option) {
    const text = getTitleText(option);

    return (
      text === 'treat' ||
      text === 'treats' ||
      text === 'other essentials' ||
      text === 'essentials' ||
      text === 'health care' ||
      text === 'healthcare' ||
      text === 'health' ||
      text === 'price' ||
      text === 'prices' ||
      text === 'size' ||
      text === 'sizes' ||
      text === '零食' ||
      text === '其他用品' ||
      text === '出行用品' ||
      text === '居家用品' ||
      text === '卫生清洁' ||
      text === '健康护理' ||
      text === '价格' ||
      text === '尺码' ||
      text.includes('treat') ||
      text.includes('essential') ||
      text.includes('health care') ||
      text.includes('healthcare') ||
      text.includes('health') ||
      text.includes('price') ||
      text.includes('size') ||
      text.includes('零食') ||
      text.includes('护理') ||
      text.includes('用品') ||
      text.includes('价格') ||
      text.includes('尺码')
    );
  }

  function injectTopBar() {
    const filterTree = getFilterTree();

    if (!filterTree) return;
    if (filterTree.querySelector('.paw-filter-topbar')) return;

    const bar = document.createElement('div');
    bar.className = 'paw-filter-topbar';

    bar.innerHTML = `
      <div class="paw-filter-topbar-left">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 7h9M17 7h3M7 17h13M4 17h1M4 12h3M11 12h9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
          <circle cx="15" cy="7" r="2" stroke="currentColor" stroke-width="1.6"/>
          <circle cx="9" cy="12" r="2" stroke="currentColor" stroke-width="1.6"/>
          <circle cx="7" cy="17" r="2" stroke="currentColor" stroke-width="1.6"/>
        </svg>
        <span>Filters</span>
      </div>
      <a class="paw-filter-clear" href="javascript:void(0)">Clear all</a>
    `;

    filterTree.prepend(bar);

    const clearBtn = bar.querySelector('.paw-filter-clear');

    clearBtn.addEventListener('click', function () {
      const nativeClear =
        document.querySelector('.boost-sd__clear-all') ||
        document.querySelector('.boost-pfs-filter-clear-all') ||
        document.querySelector('[class*="clear-all"]') ||
        document.querySelector('[class*="ClearAll"]');

      if (nativeClear) {
        nativeClear.click();
        return;
      }

      const url = new URL(window.location.href);
      url.search = '';
      window.location.href = url.toString();
    });
  }

  function getPetIconSvg() {
    return `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="7.8" cy="8.2" rx="1.7" ry="2.35" stroke="currentColor" stroke-width="1.4" fill="none"/>
        <ellipse cx="12" cy="7.1" rx="1.75" ry="2.5" stroke="currentColor" stroke-width="1.4" fill="none"/>
        <ellipse cx="16.2" cy="8.2" rx="1.7" ry="2.35" stroke="currentColor" stroke-width="1.4" fill="none"/>
        <ellipse cx="6.1" cy="13.2" rx="1.55" ry="2.15" stroke="currentColor" stroke-width="1.4" fill="none"/>
        <ellipse cx="17.9" cy="13.2" rx="1.55" ry="2.15" stroke="currentColor" stroke-width="1.4" fill="none"/>
        <path d="M8.4 18C8.4 15.6 9.9 14 12 14C14.1 14 15.6 15.6 15.6 18C15.6 19.7 14.5 20.6 13.2 20.1C12.45 19.8 11.55 19.8 10.8 20.1C9.5 20.6 8.4 19.7 8.4 18Z" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linejoin="round"/>
      </svg>
    `;
  }

  function getTagIconSvg() {
    return `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 13.2L12.2 21C11.4 21.8 10.1 21.8 9.3 21L3 14.7V5H12.7L20 12.3C20.3 12.6 20.3 12.9 20 13.2Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
        <circle cx="8" cy="10" r="1.5" stroke="currentColor" stroke-width="1.5"/>
      </svg>
    `;
  }

  function getFoodIconSvg() {
    return `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.2 11.2H18.8L17.7 18.1C17.5 19.2 16.6 20 15.5 20H8.5C7.4 20 6.5 19.2 6.3 18.1L5.2 11.2Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M8.2 11.2C8.5 8.9 9.9 7.6 12 7.6C14.1 7.6 15.5 8.9 15.8 11.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M9.5 8.6C9.7 7.5 10.6 6.7 11.7 6.7H12.3C13.4 6.7 14.3 7.5 14.5 8.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M7.8 14.2H16.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    `;
  }

  function getToyIconSvg() {
    return `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.4 8.4L15.6 15.6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <path d="M7.2 10.1C6.3 10.8 5 10.7 4.2 9.9C3.3 9 3.3 7.6 4.2 6.7C5 5.9 6.3 5.8 7.2 6.5C7.9 5.6 9.2 5.5 10.1 6.3C11 7.1 11.1 8.4 10.4 9.3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16.8 13.9C17.7 13.2 19 13.3 19.8 14.1C20.7 15 20.7 16.4 19.8 17.3C19 18.1 17.7 18.2 16.8 17.5C16.1 18.4 14.8 18.5 13.9 17.7C13 16.9 12.9 15.6 13.6 14.7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
  }

  function injectFilterTitleIcon(option, className, iconClassName, iconSvg) {
    const titleText = getTitleTextElement(option);

    if (!titleText) return;

    option.classList.add(className);

    if (titleText.querySelector('.' + iconClassName)) return;

    titleText.querySelectorAll(
      '.paw-filter-title-icon, .paw-pet-title-icon, .paw-tag-title-icon, .paw-food-title-icon, .paw-toy-title-icon'
    ).forEach(function (el) {
      el.remove();
    });

    const icon = document.createElement('span');
    icon.className = 'paw-filter-title-icon ' + iconClassName;
    icon.innerHTML = iconSvg;

    titleText.prepend(icon);
  }

  function injectFilterIcons() {
    const options = getFilterOptions();

    options.forEach(function (option) {
      if (isPetFilter(option)) {
        injectFilterTitleIcon(
          option,
          'paw-filter-option--pet-icon',
          'paw-pet-title-icon',
          getPetIconSvg()
        );
        return;
      }

      if (isFoodFilter(option)) {
        injectFilterTitleIcon(
          option,
          'paw-filter-option--food',
          'paw-food-title-icon',
          getFoodIconSvg()
        );
        return;
      }

      if (isToyFilter(option)) {
        injectFilterTitleIcon(
          option,
          'paw-filter-option--toy',
          'paw-toy-title-icon',
          getToyIconSvg()
        );
        return;
      }

      if (isBrandFilter(option) || isTagIconFilter(option)) {
        injectFilterTitleIcon(
          option,
          'paw-filter-option--tag',
          'paw-tag-title-icon',
          getTagIconSvg()
        );
      }
    });
  }

  function getBrandFilter() {
    const options = Array.from(getFilterOptions());

    return options.find(function (option) {
      return isBrandFilter(option);
    });
  }

  function getBrandContent(brandFilter) {
    return (
      brandFilter.querySelector('.boost-sd__filter-option-content') ||
      brandFilter.querySelector('.boost-pfs-filter-option-content')
    );
  }

  function getBrandItems(content) {
    return Array.from(
      content.querySelectorAll('.boost-sd__filter-option-item, .boost-pfs-filter-option-item')
    ).filter(function (item) {
      return !item.closest('.paw-brand-hot-list') && !item.closest('.paw-brand-list-wrap');
    });
  }

  function getBrandItemText(item) {
    const textEl =
      item.querySelector('.boost-sd__filter-option-item-label-text') ||
      item.querySelector('.boost-pfs-filter-option-item-text') ||
      item.querySelector('.boost-sd__filter-option-item-label') ||
      item.querySelector('.boost-pfs-filter-option-item-label') ||
      item.querySelector('.boost-sd__filter-option-item-button') ||
      item.querySelector('.boost-pfs-filter-option-item-list');

    if (!textEl) return '';

    return textEl.textContent.replace(/\s+/g, ' ').trim();
  }

  function isItemSelected(item) {
    return (
      item.classList.contains('is-selected') ||
      item.classList.contains('selected') ||
      Boolean(item.querySelector('input:checked'))
    );
  }

  function clickBrandItem(item) {
    const clickable =
      item.querySelector('input') ||
      item.querySelector('a') ||
      item.querySelector('button') ||
      item.querySelector('[role="button"]') ||
      item;

    if (clickable) {
      clickable.click();
    }
  }

  function initBrandArea() {
    const brandFilter = getBrandFilter();

    if (!brandFilter) return;

    brandFilter.classList.add('paw-filter-option--brand');

    const content = getBrandContent(brandFilter);

    if (!content) return;
    if (content.classList.contains('paw-brand-ready')) return;

    const originalItems = getBrandItems(content);

    if (!originalItems.length) return;

    content.classList.add('paw-brand-ready');

    const searchBox =
      content.querySelector('.boost-sd__filter-option-search-box') ||
      content.querySelector('.boost-pfs-filter-option-search-box') ||
      content.querySelector('input[type="search"]')?.parentElement ||
      null;

    const hotTitle = document.createElement('div');
    hotTitle.className = 'paw-brand-hot-title';
    hotTitle.textContent = '热门品牌';

    const hotList = document.createElement('div');
    hotList.className = 'paw-brand-hot-list';

    const allTitle = document.createElement('div');
    allTitle.className = 'paw-brand-all-title';
    allTitle.textContent = '全部品牌';

    const listWrap = document.createElement('div');
    listWrap.className = 'paw-brand-list-wrap';

    const hotItems = originalItems.slice(0, 6);

    hotItems.forEach(function (item) {
      const text = getBrandItemText(item);

      if (!text) return;

      const chip = document.createElement('div');
      chip.className = 'paw-brand-hot-item';
      chip.textContent = text;
      chip.title = text;

      if (isItemSelected(item)) {
        chip.classList.add('is-active');
      }

      chip.addEventListener('click', function () {
        clickBrandItem(item);
      });

      hotList.appendChild(chip);
    });

    let currentLetter = '';

    originalItems.forEach(function (item) {
      const text = getBrandItemText(item);
      const firstLetter = text ? text.charAt(0).toUpperCase() : '#';

      if (firstLetter !== currentLetter) {
        currentLetter = firstLetter;

        const letter = document.createElement('div');
        letter.className = 'paw-brand-letter';
        letter.innerHTML = `<span>${currentLetter}</span>`;

        listWrap.appendChild(letter);
      }

      listWrap.appendChild(item);
    });

    const preservedNodes = [];

    if (searchBox) {
      preservedNodes.push(searchBox);
    }

    content.innerHTML = '';

    preservedNodes.forEach(function (node) {
      content.appendChild(node);
    });

    content.appendChild(hotTitle);
    content.appendChild(hotList);
    content.appendChild(allTitle);
    content.appendChild(listWrap);
  }

  function initPawpularBoostUI() {
    if (!isFilterReady()) return;

    injectTopBar();
    injectFilterIcons();
    initBrandArea();
  }

  function debounce(fn, delay) {
    let timer = null;

    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPawpularBoostUI();

    const observer = new MutationObserver(
      debounce(function () {
        initPawpularBoostUI();
      }, 150)
    );

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  window.addEventListener('load', function () {
    initPawpularBoostUI();
  });
})();